import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Slider, FormControl } from 'components'
import RangeBuilderController from './components/RangeBuilderController/RangeBuilderController';
import styles from './RangeBuilder.scss';

const RangeBuilder = ({
    isDisabled,
    defaultMinValue,
    defaultMaxValue,
    defaultRangeValue,
    onChangeMinValue,
    onChangeMaxValue,
    minValueLabel,
    maxValueLabel,
    ...props
}) => {

    const [minValue, setMinValue] = useState(defaultMinValue);
    const [maxValue, setMaxValue] = useState(defaultMaxValue);

    const handleMinValueChange = (event) => {
        const value = parseInt(event.target.value);
        onChangeMinValue(value);
        setMinValue(value);
    };

    const handleMaxValueChange = (event) => {
        const value = parseInt(event.target.value);
        onChangeMaxValue(value);
        setMaxValue(value);
    };

    return (
        <FormControl className={styles.builder}>
            <Slider
                {...props}
                defaultValue={defaultRangeValue}
                disabled
            />
            <div className={styles.controllers}>
                <RangeBuilderController
                    value={minValue}
                    handleChange={handleMinValueChange}
                    labelText={minValueLabel}
                    isDisabled={isDisabled}
                />
                <RangeBuilderController
                    value={maxValue}
                    handleChange={handleMaxValueChange}
                    labelText={maxValueLabel}
                    isDisabled={isDisabled}
                />
            </div>
        </FormControl>
    );
};

RangeBuilder.propTypes = {
    isDisabled: PropTypes.bool,
    defaultMinValue: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number
    ]),
    defaultMaxValue: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number
    ]),
    onChangeMinValue: PropTypes.func,
    onChangeMaxValue: PropTypes.func,
    minValueLabel: PropTypes.string,
    maxValueLabel: PropTypes.string
};

RangeBuilder.defaultProps = {
    isDisabled: false,
    defaultMinValue: '',
    defaultMaxValue: '',
    onChangeMinValue: () => {},
    onChangeMaxValue: () => {},
    minValueLabel: '',
    maxValueLabel: ''

};

export default RangeBuilder;
